<template>
    <div class="container">
        <a-card title="筛选" class="search-card" ref="searchExpand" size="small">
            <div :class="expand ? 'search' : null">
                <a-form-model
                    ref="searchFrom"
                    :model="form"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                >
                    <div :class="expand ? null : 'fold'">
                        <a-row>
                            <a-col :span="8">
                                <a-form-model-item label="表单名称" prop="formName">
                                    <a-input  v-emoji v-model="form.formName" placeholder="请填写表单名称" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="表单类型" prop="cateId">
                                    <a-select v-model="form.cateId" placeholder="请选择表单类型">
                                        <a-select-option
                                            :value="item.cateId"
                                            v-for="(item, index) in cateList"
                                            :key="index"
                                        >
                                            {{ item.cateName }}
                                        </a-select-option>
                                        <!-- <a-select-option value="beijing">
                                      Zone two
                                    </a-select-option> -->
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="状态" prop="fillStatus">
                                    <a-select
                                        v-model="form.fillStatus"
                                        placeholder="请选择表单状态"
                                    >
                                        <a-select-option
                                            :value="item.itemKey"
                                            v-for="(item, index) in fillStautsList"
                                            :key="index"
                                        >
                                            {{ item.itemName }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                        <a-row v-if="expand">
                            <a-col :span="8">
                                <a-form-model-item label="发起时间" prop="timeValue">
                                    <a-range-picker
                                        value-format="YYYY-MM-DD"
                                        :placeholder="['开始时间', '结束时间']"
                                        @change="onChange"
                                        @ok="onOk"
                                        v-model="form.timeValue"
                                    />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="申请流水号" prop="fillId">
                                    <a-input-number v-model="form.fillId" :formatter="value => `${value}`" :parser="value => value.replace('.', '')"
                                    style="width: 100%;" placeholder="请输入申请流水号" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="概述" prop="summary">
                                    <a-input  v-emoji v-model="form.summary" placeholder="请输入概述" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </div>
                    <span class="search-button">
                        <a-button type="primary" @click="queryTableList">查询</a-button>
                        <a-button class="reset" style="" @click="restForm">重置</a-button>
                        <a @click="toggle" :style="{ marginLeft: '5px', fontSize: '12px' }">
                            {{ expand ? '收起' : '展开' }}
                            <a-icon :type="expand ? 'up' : 'down'" />
                        </a>
                    </span>
                </a-form-model>
            </div>
        </a-card>

        <a-card title="列表" class="search-card" ref="searchExpand" size="small" :bordered="false">
            <div>
                <a-table
                    :row-key="(row) => row.id"
                    :customRow="rowClick"
                    :data-source="dataSource"
                    :columns="columns"
                    :pagination="pagination"
                    size="middle"
                    :loading="loading"
                    class="dictTable"
                    :scroll="{ y: 500 }"
                    @change="onChangeTable"
                    :row-selection="rowSelection"
                >
                    <template slot="title">
                        <a-button-group>
                            <a-button type="primary" @click="onExportApplyForm" icon="export">导出</a-button>
                        </a-button-group>
                    </template>
                    <template slot="dbFormName" slot-scope="dbFormName, record">
                        <span @dblclick="dbTwoClick(record)" style="cursor: pointer">
                            {{ record.formName }}
                        </span>
                    </template>
                    <template slot="formNameTmp" slot-scope="text, record">
                        <div ref="popclass">
                            <!-- :getPopupContainer="() => $refs.popclass" -->
                            <a-popconfirm
                                title="确认取消跟踪该流程吗？"
                                ok-text="是"
                                cancel-text="否"
                                @confirm="handlepopConfirmConfirm(record)"
                                @cancel="handlepopConfirmCancel(record)"
                                id="btnn"
                                @visibleChange="handleVisibleChange(record)"
                                :visible="visible && record.processInstanceId == visibleId"
                            >
                                <a @click="toSave(record)">
                                    <img
                                        src="../../../assets/img/flag_red.png"
                                        v-if="record.trackStatus == 2"
                                        alt=""
                                    />
                                    <img src="../../../assets/img/flag_grey.png" v-else alt="" />
                                </a>
                            </a-popconfirm>
                        </div>
                    </template>
                    <template slot="cateType" slot-scope="text, record">
                        {{ cateList.find(item => item.cateId == record.cateId).cateName }}
                    </template>
                    <template slot="needId" slot-scope="text, record">
                        <span style="font-weight: bold;">{{text}}</span>
                    </template>
                    <template slot="statusType" slot-scope="text, record">
                        <a-tag
                            :color="fillStautsColorList.find(item => item.itemKey == record.fillStatus).itemName"
                        >
                            {{fillStautsList.find(item => item.itemKey == record.fillStatus).itemName}}
                        </a-tag>
                    </template>

                    <template slot="operation" slot-scope="text, record">
                        <a-dropdown :trigger="['click']">
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                操作
                                <a-icon type="down" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item
                                    v-show="record.fillStatus == 0  || record.fillStatus == 4"
                                >
                                    <a-button type="link" @click="onClickEdit(text, record)">
                                        编辑
                                    </a-button>
                                </a-menu-item>
                                <a-menu-item v-show="record.fillStatus == 0">
                                    <a-button type="link" @click="onClickPublish(text, record)">
                                        提交
                                    </a-button>
                                </a-menu-item>
                                 <a-menu-item v-show="record.fillStatus == 0">
                                    <a-button type="link" @click="deleteInfo(text, record)">
                                        删除
                                    </a-button>
                                </a-menu-item>
                                <a-menu-item
                                    v-show="record.fillStatus != 0 && record.fillStatus != 4"
                                >
                                    <a-button type="link" @click="onViewWaitMeApply(text, record)">
                                        查看
                                    </a-button>
                                </a-menu-item>
                                    <a-menu-item
                                >
                                    <a-button type="link" @click="copyMeApply(text, record)">
                                        复制
                                    </a-button>
                                </a-menu-item>
								<a-menu-item
									v-show="record.fillStatus == 1"
								>
								    <a-button type="link" @click="onClickStop(text, record)">
								        撤销
								    </a-button>
								</a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </template>
                </a-table>
            </div>

            <a-drawer
                title="查看表单"
                :width="1600"
                :visible="viewVisible"
                destroyOnClose
                :body-style="{ paddingBottom: '80px' }"
                @close="onViewClose"
            >
                <fm-generate-form
                    :data="formData"
                    :value="viewData"
                    ref="generateForm"
                ></fm-generate-form>
                <div
                    :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="onViewClose">取消</a-button>
                    <a-button type="primary" @click="onViewClose">确认</a-button>
                </div>
            </a-drawer>
            <a-drawer
                title="编辑表单"
                :width="1000"
                :closable="true"
                :visible="editVisible"
                :body-style="{ paddingBottom: '80px' }"
                @close="onEditClose"
                destroyOnClose
                :zIndex="999"
            >
                <a-form-model
                    ref="addForm"
                    :model="formObject"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }"
                >
                    <a-row>
                        <a-col :span="8">
                            <a-form-model-item label="所属组织及岗位" prop="organPostId">
                                <a-cascader
                                    v-model.trim="formObject.organPostId"
                                    :options="options"
                                    :show-search="{ filterOption }"
                                    placeholder="请选择所属组织及岗位"
                                    :style="{ width: '100%', textAlign: 'left' }"
                                    @change="onOrganAndJob"
                                    :getPopupContainer="triggerNode => triggerNode.parentNode"
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
                <!--                <hr style="border: 1px solid rgba(0, 0, 0, 0.1)" />-->
                <br />

                <fm-generate-form
                    :data="formData"
                    :value="editData"
                    ref="editGenerateForm"
                ></fm-generate-form>
                <div
                    :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1
                    }"
                >
                    <a-button :style="{ marginRight: '8px' }" @click="onEditClose">取消</a-button>
                    <a-button type="primary" @click="handleSubmit">确认</a-button>
                </div>
            </a-drawer>

            <a-modal
                title="指定节点审核人"
                :visible="auditUserVisible"
                @ok="handleOk"
                @cancel="handleCancel"
            >
                <a-form :form="form1" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
                    <template v-for="(item, index) in flowApproverSetList">
                        <a-form-item :label="item.taskName">
                            <select-person
                                ref="personPick"
                                :tabList="userGroupTabList"
                                v-model="userGroupObj[item.taskDefKey]"
                                width="100%"
                            />
                        </a-form-item>
                    </template>
                </a-form>
            </a-modal>

            <!--            <a-modal-->
            <!--                title="指定下一节点审核人"-->
            <!--                :visible="auditUserVisible"-->
            <!--                @ok="handleOk"-->
            <!--                @cancel="handleCancel"-->
            <!--            >-->
            <!--                <a-select-->
            <!--                    mode="nextAuditUser"-->
            <!--                    style="width: 100%"-->
            <!--                    placeholder="请选择审批人"-->
            <!--                    @change="handleNextAuditUserChange"-->
            <!--                >-->
            <!--                    <a-select-option v-for="(i, k) in nextAuditUsers" :key="k" :value="k">-->
            <!--                        {{ i.userName }}-->
            <!--                    </a-select-option>-->
            <!--                </a-select>-->
            <!--            </a-modal>-->

            <!--            <a-modal-->
            <!--                title="指定下一节点审核人"-->
            <!--                :visible="auditUserVisible"-->
            <!--                @ok="handleOk"-->
            <!--                @cancel="handleCancel"-->
            <!--            >-->
            <!--                <a-select-->
            <!--                    mode="nextAuditUser"-->
            <!--                    style="width: 100%"-->
            <!--                    placeholder="请选择审批人"-->
            <!--                    @change="handleNextAuditUserChange"-->
            <!--                >-->
            <!--                    <a-select-option v-for="(i, k) in nextAuditUsers" :key="k" :value="k">-->
            <!--                        {{ i.userName }}-->
            <!--                    </a-select-option>-->
            <!--                </a-select>-->
            <!--            </a-modal>-->
        </a-card>
    </div>
</template>

<script>
import {
    queryMyApplyList,
    getFormCate,
    getMyApplyDetailsById,
    editMyApplyDetailsById,
    startProcess,
    deletFormFillById,
    exportApplyForm
} from '@/services/myApply';
import {
    copyformFillSave
} from '@/services/processApply';
import selectPerson from '@/components/select-person/genera';
import { nextFlowNode, complete, saveFlowTrack,revokeProcess, queryFormFillById } from '@/services/form';

const columns = [
    {
        title: '申请流水号',
        dataIndex: 'id',
        align: 'center',
        scopedSlots: { customRender: 'needId' },
        width: 50
    },
    {
        title: '标题',
        dataIndex: 'formName',
        scopedSlots: { customRender: 'formName' },
        width: 300
    },
    {
        title: '',
        dataIndex: '',
        width: 15,
        scopedSlots: { customRender: 'formNameTmp' }
    },
    {
        title: '表单类型',
        dataIndex: 'cateId',
        width: 50,
        scopedSlots: { customRender: 'cateType' }
    },
    {
        title: '申请时间',
        width: 100,
        dataIndex: 'createTime'
    },
    {
        title: '办理状态',
        dataIndex: 'fillStatus',
        width: 50,
        scopedSlots: { customRender: 'statusType' }
    },
    {
        title: '概述',
        dataIndex: 'summary',
        width: 100
    },
    {
        title: '操作',
        width: 50,
        scopedSlots: { customRender: 'operation' }
    }
];

const dataSource = [];

export default {
    name: 'myApplyMgr',
    components: { selectPerson },
    data() {
        const usersTabList = [
            {
                title: '组织',
                value: 0
            },
            {
                title: '组织成员',
                value: 1
            },
            {
                title: '组织岗位',
                value: 2
            },
            {
                title: '组织岗位成员',
                value: 3
            },
            {
                title: '岗位成员',
                value: 5
            }
        ];
        const userGroupTabList = [
            {
                title: '组织岗位',
                value: 2
            },
            {
                title: '组织岗位成员',
                value: 3
            }
        ];
        return {
            form1: {},
            userGroupTabList,
            userGroupObj: {},
            flowApproverSetList: [],
            visible: false,
            visibleId: '',
            loading: false,
            expand: false,
            usersList: {},
            usersTabList,
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
            timeValue: undefined,
            form: {
                formName: undefined,
                cateId: undefined,
                fillStatus: undefined,
                currentNo: 1,
                pageSize: 10,
                startDateTime: '',
                endDateTime: '',
                timeValue: undefined,
                summary: '',
                fillId: ''
            },
            fillStautsList: [
                { itemName: '草　稿', itemKey: 0 },
                { itemName: '待审批', itemKey: 1 },
                { itemName: '审批中', itemKey: 2 },
                { itemName: '通　过', itemKey: 3 },
                { itemName: '驳　回', itemKey: 4 },
                { itemName: '作　废', itemKey: 5 },
                { itemName: '不通过', itemKey: 6 },
                { itemName: '挂　起', itemKey: 7 }
            ],
            fillStautsColorList: [
                { itemName: '#bfbfbf', itemKey: 0 },
                { itemName: 'rgb(24, 144, 255)', itemKey: 1 },
                { itemName: '#1890ff', itemKey: 2 },
                { itemName: 'rgb(79, 191, 73)', itemKey: 3 },
                { itemName: '#ff9806', itemKey: 4 },
                { itemName: '#d6dce5', itemKey: 5 },
                { itemName: 'rgb(220, 33, 39)', itemKey: 6 }
            ],
            columns: columns,
            total: 0,
            dataSource: dataSource,
            selectedRows: [],
            cateList: [
                {
                    cateId: 1,
                    cateMemo: '',
                    cateName: '行政',
                    parentId: 0,
                    sortNum: 1,
                    status: 1,
                    treeLevel: 0
                }
            ],
            visible: false,
            confirmLoading: false,
            pagination: this.$hdk.page(),
            viewVisible: false,
            formData: {
                list: [],
                config: {
                    labelWidth: 100,
                    labelPosition: 'right',
                    size: 'small',
                    customClass: '',
                    ui: 'element',
                    layout: 'horizontal',
                    labelCol: 3,
                    width: '100%',
                    hideLabel: false,
                    hideErrorMessage: false
                }
            },
            viewData: {
                input: 'input',
                text: 'text',
                radio: 'Option 1'
            },
            editData: {
                input: 'input',
                text: 'text',
                radio: 'Option 1'
            },
            editVisible: false,
            editItem: {},
            auditUserVisible: false,
            nextAuditUser: '',
            nextAuditUsers: [],
            nextAuditUserFlag: false,
            nextAuditUserType: '',
            nextAuditGroup: '',
            procInsId: '',
            formObject: {
                organPostId: []
            },
            options: [], // 级联选择数据
            userInfo: this.$hdk.userInfo.get(),
            rules: {
                organPostId: [{ required: true, message: '请选择所属组织及岗位' }]
            },
            selRowData: []
        };
    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRows) => {
                    this.selRowData = selectedRows;
                }
            };
        },
    },
    methods: {
        //表格行点击事件
        rowClick: function (record, index) {
            return {
                on: {
                    dblclick: () => {
                        if(record.fillStatus == 0 || record.fillStatus == 4){
                            this.$router.push({
                                path: '/formReview/reviewCenter/processMain',
                                query: {
                                    item: JSON.stringify(record),
                                    type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
                                }
                             });
                        } else {
                            this.$router.push({
                                path: '/formReview/reviewCenter/viewProcess',
                                query: {
                                    procInsId: record.processInstanceId,
                                    fillId: record.id,
                                    fillStatus: record.fillStatus
                                }
                            });
                        }
                        
                    }
                }
            };
        },
        dbTwoClick(row) {
            this.$router.push({
                path: '/formReview/reviewCenter/viewProcess',
                query: {
                    procInsId: row.processInstanceId,
                    fillId: row.id,
                    fillStatus: row.fillStatus
                }
            });
        },
        handleVisibleChange(row) {
            // if (row.trackStatus == 2) {
            //     this.visible = true;
            // }
        },

        handlepopConfirmConfirm(row) {
            saveFlowTrack(row).then(res => {
                console.log(res);
                this.visible = false;
                this.onQueryMyApplyList();
            });
        },

        handlepopConfirmCancel() {
            this.visible = false;
        },
        /**
         * 级联选择
         */
        onOrganAndJob(value) {
            const { $set, formObject } = this;
            // 组织岗位赋值
            $set(formObject, 'organId', value[0]);
            $set(formObject, 'postId', value[1]);

            this.formObject.customize = {};
            this.formObject.customize.organId = value[0];
            this.formObject.customize.postId = value[1];
        },
        filterOption(inputValue, path) {
            return (
                path.some(
                    option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
                ) ||
                path.some(
                    option => option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
                )
            );
        },
        toSave(row) {
            this.visible = false;
            this.visibleId = row.processInstanceId;
            console.log(row, 'row!!!!!', this.visibleId);
            if (row.trackStatus == 2) {
                this.visible = true;
            } else {
                this.visible = false;
                saveFlowTrack(row).then(res => {
                    console.log(res);

                    this.onQueryMyApplyList();
                });
            }
        },
        toggle() {
            console.log('点击了');
            this.expand = !this.expand;
        },
        initDict() {
            let that = this;
            getFormCate().then(res => {
                console.log('rs', res);
                const { data: list } = res.data;
                that.cateList = list;
            });
        },
        queryTableList() {
            sessionStorage.setItem('searchForm', JSON.stringify(this.form));
            this.form.currentNo = 1;
            this.pagination.current = 1;
            this.onQueryMyApplyList();
            sessionStorage.removeItem('Pagination');
        },

        restForm() {
            const { $refs } = this;
            sessionStorage.removeItem('searchForm')
            $refs.searchFrom.resetFields()
        },
        onQueryMyApplyList() {
            const { pagination, form } = this,
                pager = _.assign({}, pagination)
                
            this.loading = true;
            const searchForm = JSON.parse(sessionStorage.getItem('searchForm'));
            if (searchForm) {
                this.form = searchForm;
            }
            if (this.form.timeValue) {
                this.form.startDateTime = this.form.timeValue[0];
                this.form.endDateTime = this.form.timeValue[1];
            }
            
            
            this.form.currentNo = pager.current;
            this.form.pageSize = pager.pageSize;
            
            queryMyApplyList(this.form)
                .then(res => {
                    const { code, data } = res.data;
                    if (code == 200) {
                        this.dataSource =
                            data && Object.prototype.hasOwnProperty.call(data, 'rows')
                                ? data.rows
                                : [];
                        this.total =
                            data && Object.prototype.hasOwnProperty.call(data, 'total')
                                ? data.total
                                : 0;
                        
                        _.assign(pagination, {
                            total: this.total,
                            current: pager.current,
                            pageSize: pager.pageSize,
                        })
                        _.assign(form, pager.form)
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onClickEdit(text, record) {
            console.log(record, '============?record');
            this.$router.push({
                path: '/formReview/reviewCenter/processMain',
                query: {
                    item: JSON.stringify(record),
                    type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
                }
            });
            // console.log(JSON.stringify(record));
            // this.editItem = record;
            // this.usersList = {
            //     postData: [],
            //     organData: [],
            //     userData: []
            // };
            // getMyApplyDetailsById(record).then(res => {
            //     if (res.data.code === 200) {
            //         console.log('res', res.data.data);
            //         this.formData = JSON.parse(res.data.data.formData);
            //         this.editData = JSON.parse(res.data.data.fillData);
            //         this.editVisible = true;
            //         this.formObject.organPostId[0] = res.data.data.organId;
            //         this.formObject.organPostId[1] = res.data.data.postId;
            //         this.$nextTick(() => {
            //             console.log(this.formData, this.editData, '===================>formData1');
            //             this.$refs.editGenerateForm.refresh();
            //         });
            //     }
            // });
        },
        onClickPublish_back(text, record) {
            console.log(JSON.stringify(record));
            console.log('text213', text);
            console.log('record', record);
         
            startProcess(text).then(res => {
                console.log('res', res);
                if (res.data.code === 200) {
                    this.onQueryMyApplyList();
                    this.$message.success('提交成功');
                }
            });
        },

        deleteInfo(text, record) {
             const { $confirm, $message  } = this;
            console.log(text, record);
             $confirm("确认删除吗?", "提示",{
                type: "info",
                confirmButtonText: "确认",
                cancelButtonText: "取消",
            }).then(() => {
                deletFormFillById({ id: record.id }).then((res) => { 
                    if(res.data.code == 200) {
                        $message.success('删除成功');
                    }
                });

                this.onQueryMyApplyList();
            }).catch(() => {});
 
            },  

        async onClickPublishThen(procInsId) {
            this.procInsId = procInsId;
            const res = await nextFlowNode({
                procInsId: this.procInsId
            });
            if (res.data.code == 200) {
                let param = {
                    procInsId: this.procInsId,
                    nextNodeCliamUserId: '',
                    nextNodeUserType: '',
                    comment: '发起流程申请',
                    processStatus: 1
                };
                if (res.data.data == undefined) {
                    this.completeTask(param);
                } else if (Object.keys(res.data.data).length > 0) {
                    if (res.data.message == '自由选择') {
                        this.auditUserVisible = true;
                        this.flowApproverSetList = res.data.data;
                    } else {
                        this.completeTask(param);
                    }
                }
            }
        },
        async onClickPublish(text) {
            console.log(text, 'text/////////////////////');
            queryFormFillById({ id: text.id }).then(res => {

                const data =res.data.data?.fillData
                const dataObj =JSON.parse(data)
                const fileUploadValues = Object.keys(dataObj)
                .filter(key => key.startsWith('fileupload_'))
                .map(key => dataObj[key]);
                console.log('fileUploadKey', fileUploadValues);
            if (fileUploadValues.length === 0) { // 没有文件上传字段   
                    //查询流程是否启动
                    let formFill = res.data.data;
                    if (formFill != null && formFill.processInstanceId != null) {
                        //如果已经启动流程(还是草稿状态),则需要设置自由选择审批人
                        console.log('formFill-------', formFill);
                        this.onClickPublishThen(formFill.processInstanceId);
                    } else {
                        startProcess({
                            formName: text.formName,
                            fillId: text.fillId,
                            versionId: text.versionId,
                            fillData: text.fillData.value, 
                            fillId: text.id,
                            formId: text.formId
                        }).then(res => {
                            if (res.data.code == 200) {
                                // this.$message.success('提交成功')
                                this.onClickPublishThen(res.data.data);
                            
                            }
                        });
                    }

            }else { 
                     const { $confirm, $message} = this;
                    $confirm('请确认当前上传的附件是否完整。确认提交后，表单将按当前附件状态同步提交。', '提示', {
                        type: 'info',
                        confirmButtonText: '确认提交',
                        cancelButtonText: '返回编辑'
                    }).then(() => {
                         //查询流程是否启动
                    let formFill = res.data.data;
                    if (formFill != null && formFill.processInstanceId != null) {
                        //如果已经启动流程(还是草稿状态),则需要设置自由选择审批人
                        console.log('formFill-------', formFill);
                        this.onClickPublishThen(formFill.processInstanceId);
                    } else {
                        startProcess({
                            formName: text.formName,
                            fillId: text.fillId,
                            versionId: text.versionId,
                            fillData: text.fillData.value, 
                            fillId: text.id,
                            formId: text.formId
                        }).then(res => {
                            if (res.data.code == 200) {
                                // this.$message.success('提交成功')
                                this.onClickPublishThen(res.data.data);
                            
                            }
                        });
                    }

                    }).catch(() => {});

            }  


                
            });
        },
        onMyApplyView(record) {
            console.log(record);
            getMyApplyDetailsById(record).then(res => {
                if (res.data.code === 200) {
                    console.log('res', res.data.data);
                    this.formData = JSON.parse(res.data.data.formData);
                    this.viewData = JSON.parse(res.data.data.fillData);
                    this.viewVisible = true;
                    this.$nextTick(() => {
                        this.$refs.generateForm.refresh();
                    });
                }
            });
        },
        onChange(value, dateString) {
            console.log('Selected Time: ', value);
            console.log('Formatted Selected Time: ', dateString);
            // this.form.startDateTime = dateString[0];
            // this.form.endDateTime = dateString[1];
        },
        /*
         * 表格改变事件
         */
        onChangeTable(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            sessionStorage.setItem('Pagination', JSON.stringify( this.pagination));
            this.onQueryMyApplyList()
        },
        onOk(value) {
            console.log('onOk: ', value);
        },
        onViewClose() {
            this.viewVisible = false;
        },
        onEditClose() {
            this.editVisible = false;
        },
        handleSubmit() {
            console.log('record', this.editItem);
            let copyManData = new Array();
            console.log('copyManData', copyManData);
            this.$refs.editGenerateForm
                .getData()
                .then(data => {
                    console.log(data);
                    editMyApplyDetailsById({
                        id: this.editItem.id,
                        fillData: data,
                        fillId: this.editItem.fillId,
                        versionId: this.editItem.versionId,
                        copyManData: copyManData,
                        organId: this.formObject.organPostId[0],
                        postId: this.formObject.organPostId[1]
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('保存成功');
                            this.onEditClose();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    });
                })
                .catch(e => {
                    console.log('e', e);
                });
        },
        handleOk(e) {
            console.log('this.userGroupObj----', this.userGroupObj);
            this.nextAuditUserFlag = true;
            this.flowApproverSetList.map(item => {
                let node = this.userGroupObj[item.taskDefKey];
                if (
                    !node ||
                    JSON.stringify(node) == '{}' ||
                    (node.postData.length == 0 && node.userData.length == 0)
                ) {
                    this.$message.info('请选择节点: "' + item.taskName + '" 的审核人');
                    this.nextAuditUserFlag = false;
                }
            });
            if (!this.nextAuditUserFlag) {
                return;
            }
            let param = {
                procInsId: this.procInsId,
                approverSetMap: this.userGroupObj,
                comment: '发起流程申请',
                processStatus: 1 //待审批
            };
            this.completeTask(param);
        },
        handleCancel(e) {
            console.log('Clicked cancel button');
            this.auditUserVisible = false;
        },
        handleNextAuditUserChange(index) {
            console.log(`selected ${index}`);
            this.nextAuditUser = this.nextAuditUsers[index].userId;
            this.nextAuditGroup = this.nextAuditUsers[index].levelRoleId;
        },
        completeTask(param) {
            complete(param).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('提交成功');
                    this.auditUserVisible = false;
                    this.onQueryMyApplyList();
                    // this.$router.push({
                    //     path: '/formReview/reviewCenter/viewProcess',
                    //     query: { procInsId: this.procInsId }
                    // })
                }
            });
        },
        loadData() {
            this.onQueryMyApplyList();
        },
        restQuery() {
            this.form = {
                formName: '',
                cateId: '',
                fillStatus: '',
                currentNo: 1,
                pageSize: 10,
                startDateTime: '',
                endDateTime: ''
            };
            console.log('this.timeValue', this.timeValue);
            this.timeValue = undefined;
            this.loadData();
        },
        onViewWaitMeApply(text, record) {
            console.log(text, record);
            this.$router.push({
                path: '/formReview/reviewCenter/viewProcess',
                query: {
                    procInsId: record.processInstanceId,
                    fillId: record.id,
                    fillStatus: record.fillStatus
                }
            });
        },
        onClickStop(text, record) {
			const { $confirm, $message  } = this;
			console.log(text, record);
			 $confirm("确认撤销流程?", "提示",{
			    type: "info",
			    confirmButtonText: "确认",
			    cancelButtonText: "取消",
			}).then(() => {
			    revokeProcess({
					id: record.id,
			        procInsId: record.processInstanceId,
			        comment: '流程撤销',
			        values: {
			            organId: this.formObject.organPostId[0],
			            postId: this.formObject.organPostId[1]
			        }
			    }).then(res => {
			        if (res.data.code == 200) {
			            this.$message.success('流程已撤销');
			        }
					this.onQueryMyApplyList();
			    });
			}).catch(() => {});
        },

        copyMeApply(text, record) {
         const data=JSON.parse(record.fillData.value);
            copyformFillSave({
                formId: record.formId,
                formName: record.formName,
                versionId: record.versionId,
                fillData: data,
                summary: record.summary,
                organId: record.organId,
                postId: record.postId,
                sjybm: record.sjybm,
                sjjbm: record.sjjbm,
                subformids: record.subformids,
                fillformid: record.fillformid,
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('保存成功');
                    //this.onClickPublish(text);  如果有节点这个会让选择审批人
                    this.onQueryMyApplyList();
                    // this.onClose();
                }
                else {
                    this.$message.error(res.data.message);
                }
            }).catch(e => {
                console.log('e', e);
                this.isLoading = false
            });
        },
		
		onExportApplyForm() {
            const { $confirm, $message, selRowData } = this
            if (selRowData.length == 0) {
                $message.error("请选择需要导出的申请数据！")
                return;
            }
            
            $confirm("确认导出选择的数据吗？", "提示",{
                type: "info",
                confirmButtonText: "确认",
                cancelButtonText: "取消",
            }).then(() => {
                this.loading = true
                exportApplyForm({applyIds: selRowData}).then(async response => {
                    
                    const contentDisposition = response.headers.get('content-disposition');
                    let fileName = "导出数据.xlsx"; // 默认文件名
                    if (contentDisposition) {
                        // 解析响应头中的文件名（适配后端URLEncoder编码的文件名）
                        const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.*)/);
                        if (fileNameMatch && fileNameMatch[1]) {
                            fileName = decodeURIComponent(fileNameMatch[1]);
                        }
                    }
                    
                    const buffer = await response.arrayBuffer()
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    // 创建临时a标签，触发下载
                    const downloadLink = document.createElement("a");
                    // 创建blob的临时URL
                    const url = window.URL.createObjectURL(blob);
                    downloadLink.href = url;
                    downloadLink.download = fileName; // 设置下载文件名
                    document.body.appendChild(downloadLink);
                    downloadLink.click(); // 触发点击下载
            
                    // 清理临时资源，避免内存泄漏
                    document.body.removeChild(downloadLink);
                    window.URL.revokeObjectURL(url);
                    
                    $message.success('导出成功！');
                    
                    // selRowData = [];
                }).finally(() => {
                    this.loading = false
                })
            }).catch(() => {});
        }
    },
 
    mounted() {
    this.initDict();
    const savedPagination = sessionStorage.getItem('Pagination');
    if (savedPagination) {
        try {
            const parsed = JSON.parse(savedPagination);
            this.pagination.current = parsed.current || 1;
            this.pagination.pageSize = parsed.pageSize || 10;
        } catch (e) {
            console.warn('Failed to parse saved pagination', e);
        }finally {
        }
    }
        this.loadData();    
    },
    created() {
        const { userInfo } = this;
        console.log('userInfo=========', userInfo);
        // 级联数据处理
        this.options = _.map(userInfo.organPostTree, item => {
            item.postList = _.map(item.postList, subItem => {
                return { label: subItem.postName, value: subItem.postId, children: null };
            });
            return { label: item.organName, value: item.organId, children: item.postList };
        });
    }
};
</script>

<style lang="less" scoped>
/deep/ .ant-col-18 {
    width: 70% !important;
}
/deep/.ant-calendar-picker {
    width: 100% !important;
}
.search {
    margin-bottom: 54px;
}

.fold {
    width: calc(100% - 216px);
    display: inline-block;
}

.content-body {
    margin-top: 50px;
}

.operator {
    margin-bottom: 18px;
}

@media screen and (max-width: 900px) {
    .fold {
        width: 100%;
    }
}

::v-deep .dictTable {
    .ant-table-scroll {
        min-height: calc(100vh - 340px) !important;
    }
    .ant-table-thead > tr > th {
        text-align: center;
    }

    .ant-table {
        table {
            text-align: center;
        }
        .ant-table-content {
        }
    }
}

/deep/.ant-table-row-cell-break-word {
    position: relative;
    // text-align: left;
}

::v-deep .ant-popover-buttons {
    text-align: center !important;
}

::v-deep .ant-popover-inner-content {
    width: 208px;
}
</style>
